module.exports = __webpack_public_path__ + "img/default-homepage-reviews-white.fa421482.png";